import React from 'react';
import { Card, ListGroup, Row, Col } from 'react-bootstrap';

const PrivacyScreen = () => {
  return (
    <Row className='justify-content-center'>
      <Col md={10}>
        <Card className='shadow-sm'>
          <Card.Body>
            <Card.Title className='mb-3'>Privacy & Verzendinstructies</Card.Title>

            <p variant='info'>
                Aangeboden prijs geldt alleen voor de komende 48 uur. Na 48 uur moet elk boek opnieuw worden vernieuwd voordat het kan worden verzonden.
            </p>

            <h5>Hoe moeten de boeken worden verzonden?</h5>
            <ListGroup variant='flush' className='mb-3'>
              <ListGroup.Item>
                De boeken moeten schoon, heel en compleet zijn.
              </ListGroup.Item>
              <ListGroup.Item>
                Geen ontbrekende pagina&apos;s, geen zware beschadigingen, geen vocht- of schimmelsporen.
              </ListGroup.Item>
              <ListGroup.Item>
                Gebruik een stevige verpakking zodat het boek tijdens transport niet beschadigd raakt.
              </ListGroup.Item>
              <ListGroup.Item>
                De omslag en rug moeten intact zijn, en het boek moet goed beschermd verzonden worden.
              </ListGroup.Item>
            </ListGroup>

            <h5>Voorbeeld van een goed verzendbaar boek</h5>
            <ListGroup variant='flush' className='mb-3'>
              <ListGroup.Item>
                <strong>Voorbeeld:</strong> Een paperback met nette kaft, duidelijke rug, geen pagina&apos;s missen,
                geen vouwen, geen vochtplekken en geen duidelijke slijtage.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Niet goed:</strong> Boek met ontbrekende pagina&apos;s, gescheurde kaft, vochtige bladeren,
                pagina&apos;s met vlekken of een beschadigde rug.
              </ListGroup.Item>
            </ListGroup>

            <p className='mb-0'>
              Door de boeken te verzenden, bevestigt u dat de aangeboden items voldoen aan de bovenstaande voorwaarden.
            </p>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default PrivacyScreen;
